import React from "react";
import { CFormGroup, CLabel, CCol } from "@coreui/react";

import ErrorInput from "../ErrorInput";

function CustomInput({
  options,
  name,
  control,
  required,
  errors,
  onBlur,
  defaultValue,
  placeholder,
  type,
  register,
  ...props
}) {
  const invalid = (errors, name) => {
    return errors[name] ? true : false;
  };

  return (
    <CFormGroup row>
      <CCol md="4">
        <CLabel>{`${placeholder}${required ? "*" : ""}`}</CLabel>
      </CCol>
      <CCol xs="12" md="8">
        <input
          name={name}
          onBlur={onBlur}
          type={type}
          defaultValue={defaultValue || ""}
          ref={register({
            required: "error message", // <p>error message</p>
          })}
          className="form-control"
        />
        {invalid(errors, name) ? (
          <ErrorInput text={`${placeholder} es obligatorio`} />
        ) : (
          <></>
        )}
      </CCol>
    </CFormGroup>
  );
}

export default CustomInput;
